export const HEADER_REMOTE_STORAGE_INSTANCE_ID = 'x-remote-storage-instance-id'
export const HEADER_REMOTE_STORAGE_USER_ID = 'x-remote-storage-user-id'
